import { FC } from 'react';
import cls from './score-chart.module.scss';
import { Icon } from 'shared/ui/icon/icon';
import { ICONS } from 'shared/constants/images';
import { useTranslation } from 'hooks';

interface ScoreChartProps {
  score: number;
  change?: number;
  className?: string;
}

export const ScoreChart: FC<ScoreChartProps> = ({
  score,
  change,
  className = '',
}) => {
  const { t } = useTranslation();
  const normalizedScore = Math.max(0, Math.min(10, score));

  const position = (normalizedScore / 10) * 100;

  const previousScore = normalizedScore + (change ?? 0);
  const prevScorePosition = (previousScore / 10) * 100;

  return (
    <div className={`${cls.scoreChart} ${className}`}>
      <div className={cls.chartContainer}>
        <div className={cls.chartBar}>
          <div className={cls.lowSection}>
            <span>{t('low', undefined, 'low')}</span>
          </div>
          <div className={cls.medSection}>
            <span>{t('med', undefined, 'med')}</span>
          </div>
          <div className={cls.highSection}>
            <span>{t('high', undefined, 'high')}</span>
          </div>

          <div className={cls.progressLine} style={{ width: `${position}%` }} />
          {change && (
            <div
              className={cls.indicatorLine}
              style={{ left: `${prevScorePosition}%` }}
            />
          )}
          {change && (
            <div
              className={cls.scoreIndicator}
              style={{ left: `${prevScorePosition}%` }}
            >
              <Icon pathToIcon={ICONS.triangle} size={12} />
            </div>
          )}
        </div>
      </div>

      <div className={cls.scale}>
        <span>0</span>
        <span>2</span>
        <span>4</span>
        <span>6</span>
        <span>8</span>
        <span>10</span>
      </div>
    </div>
  );
};
